var m = require('mithril');
var animations = require('../../libs/animations');
var session = require('../../auth/models/session');
var edit = require('../../layout/components/edit');
var columnForm = require('../../data/components/columnModal');
var modalForm = require('../../layout/components/modalForm');
var boolBox = require('../../components/boolBox');
var pointWrite = require('./writeModal');
var multiPointWriteModal = require('./multiPointWriteModal');
var pointTrendModal = require('./pointTrendModal');
var pointOverride = modalForm(require('../models/override'));
var Point = require('../models/point');
var isAggregatePoint = require('../isAggregatePoint');
var pointSubscriber = require('../../../javascripts/components/pointSubscriberClass')
var canWriteColumn = require('../canWriteColumn');

function getPointRid(column) {
  return column && column.in && column.in['@rid'];
}

function pointDetailHref(column) {
  var pointRid = getPointRid(column);
  if (!pointRid) return undefined;

  var href = '/#!/point/' + String(pointRid).slice(1);
  if (column['@rid']) {
    href += '?column=' + encodeURIComponent(column['@rid']);
  }
  return href;
}

function syncPointSubscription(ctrl, nextColumn) {
  if (!ctrl.pointSubscriberObj) return false;

  var previousPointRid = ctrl.pointRid || getPointRid(ctrl.column);
  var nextPointRid = getPointRid(nextColumn);
  var changed = previousPointRid !== nextPointRid;

  if (previousPointRid && changed) {
    ctrl.pointSubscriberObj.unsubscribe(ctrl);
  }

  ctrl.column = nextColumn;

  if (nextPointRid && ctrl.pointRid !== nextPointRid) {
    ctrl.pointSubscriberObj.subscribe(ctrl);
    ctrl.pointRid = nextPointRid;
  }

  return changed;
}

var pointValue = {
  oninit : function (vnode) {
    this.column = vnode.attrs.columnRecord;
    this.options = vnode.attrs.options;
    this.parentReinitialize = vnode.attrs.parentReinitialize;
    
    if(!vnode.attrs.textAlign || vnode.attrs.textAlign === 'left') this.textAlign = 'start';
    if(vnode.attrs.textAlign === 'center') this.textAlign = 'center';
    if(vnode.attrs.textAlign === 'right') this.textAlign = 'end';
    this.tdClass = vnode.attrs.tdClass;
  },
  onremove: function (vnode) {
    if (this.pointSubscriberObj) {
      this.pointSubscriberObj.unsubscribe(this);
    }
  },
  oncreate: function (vnode) {
    this.pointSubscriberObj = new pointSubscriber();
    syncPointSubscription(this, this.column);
  },
  onupdate: function (vnode){
    var nextColumn = vnode.attrs.columnRecord;
    this.options = vnode.attrs.options;
    this.parentReinitialize = vnode.attrs.parentReinitialize;
    this.tdClass = vnode.attrs.tdClass;
    if(!vnode.attrs.textAlign || vnode.attrs.textAlign === 'left') this.textAlign = 'start';
    if(vnode.attrs.textAlign === 'center') this.textAlign = 'center';
    if(vnode.attrs.textAlign === 'right') this.textAlign = 'end';

    if(syncPointSubscription(this, nextColumn)){
      m.redraw();
      return;
    }
    this.column = nextColumn;
  },
  view: function (vnode) {
    var ctrl = this;
    var interactionsDisabled = ctrl.options && ctrl.options.disableInteractions;
    var isAggregate = isAggregatePoint(ctrl.column);
    var openTrendChart = function () {
      return pointTrendModal.open(ctrl.column);
    };
    var clickFunction = function (e) {
      e.preventDefault();
      // A disabled point cell remains read-only, but its trend can still be viewed.
      if (interactionsDisabled) {
        return openTrendChart();
      }

      if (edit.vm.editing()) {
        return columnForm.editDialogue(ctrl.column, {submitCallback: ctrl.parentReinitialize});
      }

      if (!canWriteColumn(ctrl.column)) {
        return openTrendChart();
      }

      if (isAggregate) {
        return openTrendChart();
      }

      if (Number(ctrl.column.in.overrides)) {
          return pointOverride.editDialogue(ctrl.column, vnode.attrs.parentRid);
      }
      if (ctrl.column.in.writeGroup) {
        multiPointWriteModal.editDialogue(ctrl.column, vnode.attrs.parentRid);
      } else if (Number(ctrl.column.in.writable)) {
        pointWrite.editDialogue(ctrl.column, vnode.attrs.parentRid);
      } else {
        openTrendChart();
      }
    };

    if (ctrl.column.in.unit === 'bool') {
      return m(boolBox, {
        column: ctrl.column,
        pointRecord: ctrl.column.in,
        tdClass: vnode.attrs.tdClass,
        tdStyle: vnode.attrs.tdStyle,
        disableInteractions: interactionsDisabled,
        clickFunction: clickFunction,
        href: pointDetailHref(ctrl.column),
        linkTitle: edit.vm.editing() ? 'Edit point binding' : 'View trend chart',
        parentReinitialize: ctrl.parentReinitialize
      });
    }

    var displayValue = Point.readValue(Date.now() - ctrl.column.in.time < 3600000 ? ctrl.column.in : undefined) || 'null';
    
    var displayColor = (Number(ctrl.column.in.overrideActive) ? '.yellow' :  (ctrl.column.in.alarmStatus == 'Alarm Tripped' ? '.red' : '.blue'))
    var valueSpan;
    var supportsWriteOrOverride = !interactionsDisabled && !isAggregate && (Number(ctrl.column.in.writable) || Number(ctrl.column.in.overrides));
    var textDecStyles = {
      'text-decoration-line': [
        Date.now() - ctrl.column.in.time > 60000 ? 'line-through' : '',
        supportsWriteOrOverride ? 'underline' : ''
      ].filter(Boolean).join(' '),
      'text-decoration-color': supportsWriteOrOverride ? '#58abe2' : 'inherit',
      'text-decoration-style': 'solid',
    };

    if (Number(session.user().typewriterEffect)) {
      valueSpan = [
        m('span.ma0' + displayColor, {
          typewriterString: displayValue,
          onupdate: animations.typer,
          style: textDecStyles,
        }, displayValue),
      ];
    } else {
      valueSpan = m('span.ma0' + displayColor, { style: textDecStyles }, displayValue);
    }

    return m(`td.ph1${ctrl.tdClass ? ctrl.tdClass : '.bb.bl-0'}.nowrap`, { key: vnode.attrs.key, onclick: clickFunction, style: vnode.attrs.tdStyle }, [
      m(`a.f4.pointer.tl.flex.justify-${edit.vm.editing() ? 'start' : ctrl.textAlign}`, {
        href: pointDetailHref(ctrl.column),
        'data-point-rid': ctrl.column.in['@rid'],
        'aria-haspopup': 'dialog',
        title: edit.vm.editing() ? 'Edit point binding' : 'View trend chart',
        style: {
          'user-select': 'none',
          '-webkit-user-select': 'none',
          '-moz-user-select': 'none',
          '-ms-user-select': 'none'
        }
      }, [
        m('span.moon-gray', valueSpan),
        m('span.v-top.dib.moon-gray', {style: {fontSize: '10px'}}, '  ' + Point.formatUnit(ctrl.column.in))
      ])
    ])
  },
};

module.exports = pointValue;
